export const uk = {
    'add-button': 'Добавить',
    'cancel-button': 'Отменить',
    'select-campaigns': 'Выбор кампании',
    'select-campaigns-and-groups': 'Выбор кампании и группы'
};
